var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-single"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"btns"},[_c('div',{staticClass:"yes btn",on:{"click":function($event){return _vm.$emit('yes')}}},[_vm._v("知道了")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }